export const getDropdownConfigs = (role) => ({
  trfx: {
    placeholder: 'TRFX',
    items: [
      {
        label: 'Run Tests',
        icon: 'pi pi-play',
        value: '/trfx-run-tests',
      },
      {
        label: 'Test Executions',
        icon: 'pi pi-file-check',
        value: '/trfx-test-executions',
      },
      {
        label: 'All Executions',
        icon: 'pi pi-list',
        value: '/trfx-all-executions',
      },
      ...(role === 'jenkins'
        ? [
            {
              label: 'AI Analysis',
              icon: 'pi pi-microchip-ai',
              value: '/ai-analysis',
            },
          ]
        : []),
    ],
  },
  urls: {
    placeholder: 'Urls',
    items: [
      {
        label: 'Add Url',
        icon: 'pi pi-plus',
        value: '/add-url',
      },
      {
        label: 'Edit Url',
        icon: 'pi pi-pencil',
        value: '/edit-url',
      },
      {
        label: 'Delete Url',
        icon: 'pi pi-times',
        value: '/delete-url',
      },
    ],
  },
  scopes: {
    placeholder: 'Scopes',
    items: [
      {
        label: 'View Custom Scope',
        icon: 'pi pi-eye',
        value: '/view-custom-scopes',
      },
      {
        label: 'Associate Customer',
        icon: 'pi pi-users',
        value: '/associate-component',
      },
    ],
  },
  airProducts: {
    placeholder: 'Air Products',
    items: [
      {
        label: 'ATC',
        icon: 'pi pi-box',
        value: '/air-products-atc',
      },
      {
        label: 'Marketplace',
        icon: 'pi pi-shopping-bag',
        value: '/air-products-marketplace',
      },
    ],
  },
});
